import {
  isPipelineOverviewEnabled,
  isPipelinesBuildChainsSnapshotDependenciesEnabled,
} from '../../../../utils/featureToggles'
import {notNull} from '../../../../utils/guards'

export enum PipelineRunTabs {
  PIPELINE = 'pipeline',
  ARTIFACTS = 'artifacts',
  CHAIN = 'chain',
}

export const pipelineRunTabs = [
  {id: PipelineRunTabs.PIPELINE, title: 'Pipeline'},
  isPipelineOverviewEnabled ? null : {id: PipelineRunTabs.ARTIFACTS, title: 'Artifacts'},
  isPipelinesBuildChainsSnapshotDependenciesEnabled
    ? {id: PipelineRunTabs.CHAIN, title: 'Chain'}
    : null,
].filter(notNull)
